module.exports = __webpack_public_path__ + "static/img/subheader-10.3f60c4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subheader-10.jpg
// module id = i3Hp
// module chunks = 1